import { NgModule } from '@angular/core'

import { TrainingComponent } from './training.component'
import { TrainingRoutingModule } from './training-routing.module'
import { SharedModule } from '../shared/shared.module'
import { VideoPlayerModule } from '../shared/video-player/video-player.module'
import { VerticalSearchModule } from '../shared/vertical-search/vertical-search.module'
import { TagsModule } from '../libs/tags/tags.module'

@NgModule({
  imports: [TrainingRoutingModule, SharedModule, TagsModule, VideoPlayerModule, VerticalSearchModule],
  exports: [TrainingComponent],
  declarations: [TrainingComponent]
})
export class TrainingModule {}
